// extracted by mini-css-extract-plugin
module.exports = {"tableBorders":"DocumentInfoMetadata_tableBorders__3LUPu"};